import { useInstance } from 'intact-vue-next';
import { watchState } from '../../hooks/useState';
import { useReceive } from '../../hooks/useReceive';
export function useDisableRow(loopData, data) {
  var instance = useInstance();
  var enabledKeys = [];
  var disabledKeys = [];
  var allKeys = [];
  function setDisabledKeys() {
    var _instance$get = instance.get(),
      rowKey = _instance$get.rowKey;
    enabledKeys = [];
    disabledKeys = [];
    allKeys = [];
    loopData(function (item, index) {
      var key = rowKey(item, index);
      if (isDisabled(item, index, key)) {
        disabledKeys.push(key);
      } else {
        enabledKeys.push(key);
      }
      allKeys.push(key);
    });
  }
  function isDisabled(data, index, key) {
    var _instance$get2 = instance.get(),
      disableRow = _instance$get2.disableRow;
    if (disableRow && disableRow(data, index, key)) return true;
    return false;
  }
  function isDisabledKey(key) {
    return disabledKeys.indexOf(key) > -1;
  }
  function getEnableKeys() {
    return enabledKeys;
  }
  function getAllKeys() {
    return allKeys;
  }
  // instance.on('$receive:children', setDisabledKeys);
  useReceive(['children'], setDisabledKeys);
  watchState(data, setDisabledKeys);
  return {
    isDisabled: isDisabled,
    getEnableKeys: getEnableKeys,
    isDisabledKey: isDisabledKey,
    getAllKeys: getAllKeys
  };
}